import React from 'react'

import { TableFooter, Span, Row } from 'components'
import { EditIcon, DeleteIcon } from 'components/Icons'
import { SPACING } from 'utils'

import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableCellStyled,
  TableBodyStyled
} from './TableActions.styles'

interface TableProps {
  rows: any[]
  onDelete?: (row: any) => void
  onEdit?: (row: any) => void
}

export const TableActions = ({ rows, onDelete, onEdit }: TableProps) => {
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(15)

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled stickyHeader>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">Motivo</TableCellStyled>
              <TableCellStyled align="left">E-mail</TableCellStyled>
              <TableCellStyled align="left">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : rows
            ).map((row, index) => (
              <TableRowStyled
                key={`${row}-table-body`}
                evenNumber={index % 2 != 0}
              >
                <TableCellStyled align="left">{row.dsMotivo}</TableCellStyled>
                <TableCellStyled align="left">
                  {row.emails.map((item) => (
                    <>
                      <Row
                        marginBottom={SPACING.spacing10}
                        key={item.idEmailFaleConosco}
                      >
                        <Span text={item.dsEmail} />
                      </Row>
                    </>
                  ))}
                </TableCellStyled>
                <TableCellStyled>
                  <EditIcon
                    onClick={() => onEdit(row)}
                    marginRight={SPACING.spacing15}
                  />
                  <DeleteIcon cursor="pointer" onClick={() => onDelete(row)} />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={rows}
        typeFooter="offline"
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}
